export default {
    self: {
        url: 'https://doen.ganymede.digitalnatives.nl'
    },
    newSite: {
        url: 'https://vriendenloterijfonds.doen.natives.dev'
    },
    api: {
        endpoint: 'https://cms.doen.natives.dev/graphql',
        token: 'Bearer QkMpJUM2PBoacsE1M52BhZObgGRapdx1'
    },
    sites: {
        'mijn.vriendenloterijfonds.doen.natives.dev': {
            nl: 3
        },
    },
    defaults: {
        siteId: 3,
        locale: 'nl',
        title: 'Stichting DOEN',
        meta: {
            description: 'Stichting DOEN'
        }
    },
    siteConfig: {
        3: {
            title: '<%= title %> | VriendenLoterij Fonds'
        }
    },
    themes: {
        3: 'bglf',
    },
    gtm: {
        3: 'GTM-TRFG39P',
    },
    quickscan: {
        enabled: [3]
    },
    mijnomgeving: {
        enabled: [3]
    },
    projects: {
        enabled: [3]
    },
};
